import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomFileUpload {
    file: File;
    line: string;
}

export interface Files {
    files: CustomFileUpload[];
}

export type CustomRFQFileUploadState = Readonly<Files>;

export const initialRFQFileUploadState: CustomRFQFileUploadState = {
    files: [],
};

export const customRFQFileUploadReducer = createTypedReducer(initialRFQFileUploadState, {
    "Custom/RFQFileUpload/AddFile": (draft: Draft<CustomRFQFileUploadState>, { file }: { file: CustomFileUpload }) => {
        return {
            ...draft,
            files: [...draft.files, file],
        };
    },

    "Custom/RFQFileUpload/ClearFiles": (draft: Draft<CustomRFQFileUploadState>) => {
        return {
            ...draft,
            files: [],
        };
    },
});
